import React, { useState } from 'react';
import { Division } from "../interfaces";

const validDivisions = Object.values(Division)
  .filter(v => typeof v === 'number' && v !== Division.UNKNOWN) as Division[];

const divisionLabels: Record<Division, string> = {
    [Division.UNKNOWN]: 'Unknown',
    [Division.GREEN]: 'Green',
    [Division.RED]: 'Red',
    [Division.MAROON]: 'Maroon',
    [Division.BLUE]: 'Blue',
};

export function DivisionCheckbox(props: {
    divisionsToShow : Division[],
      onChange?: (checked: Division[]) => void;
    }) {

  // Default all valid divisions checked
  const [checkedDivisions, setCheckedDivisions] = useState<Division[]>([...validDivisions]);

  const handleChange = (division: Division) => {
    const newChecked = checkedDivisions.includes(division)
      ? checkedDivisions.filter(d => d !== division)
      : [...checkedDivisions, division];

    setCheckedDivisions(newChecked);
    props.onChange?.(newChecked);
  };

  return (
    <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
    {props.divisionsToShow.map(division => (
      <label key={division}>
        <input
          type="checkbox"
          checked={checkedDivisions.includes(division)}
          onChange={() => handleChange(division)}
          style={{ marginRight: '6px' }}
        />
        Show {divisionLabels[division]}
      </label>
    ))}
  </div>
  );
};
